// extracted by mini-css-extract-plugin
module.exports = {"quickLinks":"styles-module__quickLinks___2c-AQ","title":"styles-module__title___2AzgY","link":"styles-module__link___txRmb"};